import { tryDoFetchWithRedirect } from "../../../lib/tryDoFetchWithRedirect";

export const doResetPw = async (userName) => {
  const encoded = btoa(userName);
  const body = `{"email":"${encoded}"}`;
  await tryDoFetchWithRedirect("/research/japi/user/forgot-password", body, "POST");
};
